export default "__VITE_ASSET__azrGo8AB__"